import CarouselContainer from './carousel_container';

export default CarouselContainer;
